<template>
  <div class="record-item-wrap">
    <div class="item-title" v-if="data.key">{{data.key}}</div>
    <div :class="{
      'item-content': true,
      'little-item':!data.key && data.value
    }">{{data.value || gettext('暂无')}}</div>
  </div>
</template>

<script>
  export default {
    props: {data: {}}
  }
</script>

<style lang="scss" scoped>
.record-item-wrap {
  position: relative;
  padding: 24px 0 16px;
  border-bottom: 1px solid #f2f3f6;
  .item-title {
    font-family: DiDiSans-Pro-Regular;
    font-size: 24px;
    color: #8D9099;
    line-height: 32px;
    margin-bottom: 16px;
  }

  .item-content {
    font-family: DiDiSans-Pro-Medium;
    font-size: 36px;
    color: #282B33;
    line-height: 44px;

    &.little-item {
      font-size: 28px;
    }
  }
}
</style>
